module.exports = "/static/media/certificate.ad4d8529.svg";